import * as React from "react";
import type { InnerSvySwitchProps } from "./SvySwitch.interface";
import { SwitchRoot, SwitchThumb } from "./SvySwitch.style";
import { withLabel } from "@/helpers/withLabel";

const InnerSvySwitch = React.forwardRef<HTMLButtonElement, InnerSvySwitchProps>((props, ref) => {
    const { value, onChange, defaultValue, ...otherProps } = props;
    return (
        <SwitchRoot
            ref={ref}
            data-testid="svy-switch"
            onCheckedChange={onChange}
            checked={value}
            value={value ? "on" : "off"}
            defaultValue={defaultValue ? "on" : "off"}
            {...otherProps}
        >
            <SwitchThumb />
        </SwitchRoot>
    );
});

InnerSvySwitch.displayName = "SvySwitch";

export const SvySwitch = withLabel(InnerSvySwitch, { orientation: "horizontal-reverse" });
